import axios from "Services/api";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getCourseAssignmentQuestions = createAsyncThunk("assignment/courseQuestion", async (data) => {
  try {
    const response = await axios.post(`/GetCourseAssignmentQuestions`, data);
    return response.data;
  } catch (error) {
    return error;
  }
});

export const getAssignmentQuestions = createAsyncThunk("assignment/question", async (data) => {
  try {
    const response = await axios.post(`/GetUserAssignmentQuestions`, data);
    return response.data;
  } catch (error) {
    return error;
  }
});

export const submitAssignmentAnswer = createAsyncThunk("assignment/submitAssignmentAnswer", async (data) => {
  try {
    const response = await axios.post(`/SubmitAssignmentAnswer`, data);
    return response.data;
  } catch (error) {
    return error;
  }
});

export const getModuleScore = createAsyncThunk("assignment/moduleScore", async (data) => {
  try {
    const response = await axios.post(`/GetModuleScore`, data);
    return response.data;
  } catch (error) {
    return error;
  }
});

export const bookmarkQuestion = createAsyncThunk("assignment/bookmarkQuestion", async (data) => {
  try {
    const response = await axios.post(`/BookmarkedQuestion`, data);
    return response.data;
  } catch (error) {
    return error;
  }
});